import {ITheme} from 'contexts/ThemeContext';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) => {
  return CreateResponsiveStyle(
    {
      container: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      },
      activeElement: {
        width: 11,
        height: 11,
        borderRadius: 6,
        backgroundColor: props.colors.purple(1),
        margin: 3,
      },
      usualElement: {
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor: props.colors.gray,
        margin: 3,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        container: {
          paddingBottom: 20,
        },
      },
      [maxSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        container: {
          height: 33,
        },
      },
    },
  )();
};
